$.getScript(
  "//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js"
).done(function () {
  quickView();
});

// On iOS Safari the app renders .fancybox-wrap as a SIBLING of the fixed
// .fancybox-overlay (a direct child of <body>), so its inline "position:absolute;
// top:..." is measured against the document instead of the viewport and the popup
// gets pinned to the top of the page. On Android the wrap sits inside the fixed
// overlay so it works. To make both behave the same we force the wrap to be a
// viewport-centered fixed modal, and keep re-applying it because the app rewrites
// the inline styles after we set them.
var qvPositionObserver = null;

function forceQuickViewPosition() {
  var wrap = document.querySelector(".fancybox-wrap");
  if (!wrap) return;
  wrap.style.setProperty("position", "fixed", "important");
  wrap.style.setProperty("top", "50%", "important");
  wrap.style.setProperty("left", "50%", "important");
  wrap.style.setProperty("right", "auto", "important");
  wrap.style.setProperty("bottom", "auto", "important");
  wrap.style.setProperty("margin", "0", "important");
  wrap.style.setProperty("transform", "translate(-50%, -50%)", "important");
  wrap.style.setProperty(
    "-webkit-transform",
    "translate(-50%, -50%)",
    "important"
  );
  wrap.style.setProperty("max-height", "85vh", "important");
}

function observeQuickViewPosition() {
  var wrap = document.querySelector(".fancybox-wrap");
  if (!wrap) return;
  forceQuickViewPosition();

  if (typeof MutationObserver === "undefined") {
    // Fallback for very old browsers: re-apply a few times.
    var attempts = 0;
    var interval = setInterval(function () {
      forceQuickViewPosition();
      if (++attempts > 20 || !document.querySelector(".fancybox-wrap")) {
        clearInterval(interval);
      }
    }, 100);
    return;
  }

  if (qvPositionObserver) qvPositionObserver.disconnect();
  qvPositionObserver = new MutationObserver(function () {
    // Disconnect while we write so our own changes don't retrigger the observer.
    qvPositionObserver.disconnect();
    forceQuickViewPosition();
    qvPositionObserver.observe(wrap, {
      attributes: true,
      attributeFilter: ["style"],
    });
  });
  qvPositionObserver.observe(wrap, {
    attributes: true,
    attributeFilter: ["style"],
  });
}

function stopQuickViewPositionObserver() {
  if (qvPositionObserver) {
    qvPositionObserver.disconnect();
    qvPositionObserver = null;
  }
}

//Quick View
function quickView() {
  $(".quick-view-button .quick-view").unbind("click");
  $(".quick-view-button .quick-view").off("click");
  $(document).on("click", ".quick-view-button .quick-view", function (e) {
    e.preventDefault();
    var variant_length = 0;
    if ($("#quick-view").length == 0) {
      $("body").append('<div id="quick-view"></div>');
    }
    var product_handle = $(this).data("handle");
    $("#quick-view").addClass(product_handle);
    jQuery.getJSON("/products/" + product_handle + ".js", function (product) {
      getQuickViewProductData(product);
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var options = product.options;
      var url = "/products/" + product_handle;
      $(".qv-product-title").text(title);
      $(".qv-product-type").text(type);
      $(".qv-product-description").html(desc);
      $(".view-product").attr("href", url);

     if (Theme.settings.wishlist_enabled) {
       const swymBtn = document.querySelector(
         ".qv-add-to-cart__add-to-favourites .swym-button"
       );

       if (swymBtn) {
         swymBtn.setAttribute("class", "swym-button product_" + product.id);

         const aisHit = document.querySelector(
           `.ais-product[data-product-id="${product.id}"]`
         );

         swymBtn.dataset.variantId =
           aisHit?.dataset.variantId || product.variants[0].id;

         swymBtn.dataset.productId = product.id;
         swymBtn.dataset.productUrl = window.location.origin + url;
       }
     }


      document.dispatchEvent(new CustomEvent("quickview:open"));

      if (Theme.settings.reviews_enabled) {
        window.pwr("render", {
          api_key: Theme.settings.reviews.api_key,
          locale: Theme.settings.reviews.locale,
          merchant_group_id: Theme.settings.reviews.group_id,
          merchant_id: Theme.settings.reviews.merchant_id,
          page_id: product.id,
          components: {
            CategorySnippet: "qv-pwr-stars",
          },
        });
      }

      $(images).each(function (i, image) {
        var image_embed = '<div><img src="' + image + '"></div>';
        image_embed = image_embed
          .replace(".jpg", "_800x.jpg")
          .replace(".png", "_800x.png");
        $(".qv-product-images__carousel").append(image_embed);
        $(".qv-product-images__thumbnails").append(image_embed);
      });

      $(".qv-product-images__carousel")
        .slick({
          arrows: true,
          dots: false,
          slidesToShow: 1,
          autoplay: false,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          infinite: true
        })
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          $(".qv-product-images__thumbnails .selected").removeClass("selected");
          $(".qv-product-images__thumbnails div")
            .eq(nextSlide)
            .addClass("selected");
        });

      $(".qv-product-images__thumbnails div").eq(0).addClass("selected");

      $(".qv-product-images__thumbnails div").on("click", function (e) {
        e.preventDefault();
        $(".qv-product-images__carousel").slick("slickGoTo", $(this).index());
      });

      $(".qv-product-images").css("opacity", "1");

      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = ".option." + opt.toLowerCase();
        $(".qv-product-options").append(
          '<div class="option-selection-' +
            opt.toLowerCase() +
            '"><span class="option">' +
            opt +
            '</span><select class="option-' +
            i +
            " option " +
            opt.toLowerCase() +
            '"></select></div>'
        );
        $(option.values).each(function (i, value) {
          $(".option." + opt.toLowerCase()).append(
            '<option value="' + value + '">' + value + "</option>"
          );
        });
      });

      $(options).each(function (i, option) {
        var opt = option.name;

        var selectClass = ".option." + opt.toLowerCase();
        var cls = "";
        var title = opt;
        if (title == "size" || title == "Size") {
          var tag = product.tags.find(function (tag) {
            return tag.startsWith("Size Type_");
          });
          if (tag) {
            title = "Pick your " + tag.replace("Size Type_", "");
          } else {
            title = "Pick your US size";
          }
        }
        $(".qv-product-swatch").append(
          '<div class="ctm_swatches hide swatch-option-selection-' +
            opt.toLowerCase() +
            '" role="group" aria-labelledby="swatch-label-' +
            opt.toLowerCase() +
            "-" +
            i +
            '"><span class="option" id="swatch-label-' +
            opt.toLowerCase() +
            "-" +
            i +
            '">' +
            title +
            '</span><div class="option-' +
            i +
            " option " +
            opt.toLowerCase() +
            '" role="radiogroup" aria-label="' +
            title +
            ' options"></div></div>'
        );
        $(option.values).each(function (i, value) {
          var cls = "";
          var len = product.variants.length;
          var sold_out = false;
          for (var i = 0; i < len; i++) {
            var second_opt = product.variants[i].option2;
            if (second_opt == value) {
              if (!product.variants[i].available) {
                sold_out = true;
              }
            }
          }
          if (i == 0) {
            //             cls = "ctm_active";
            cls = "";
          }
          if (sold_out) {
            cls = "soldout";
          }
          $(".option." + opt.toLowerCase()).append(
            '<div aria-label="' +
              value +
              '" class="ctm_radios ' +
              cls +
              '" data-value="' +
              value +
              '">' +
              value +
              "</div>"
          );
        });
      });
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          $(".qv-add-button").prop("disabled", true).val("Sold Out");
          $(".qv-add-to-cart").hide();
          $(".qv-product-price").text("Sold Out").show();
          return true;
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $(".qv-product-price").text("$" + price);
          if (original_price > 0) {
            $(".qv-product-original-price")
              .text("$" + original_price)
              .show();
          } else {
            $(".qv-product-original-price").hide();
          }
          $("select.option-0").val(v.option1);
          $("select.option-1").val(v.option2);
          $("select.option-2").val(v.option3);
          return false;
        }
      });
      variant_length = product.variants.length;

      setTimeout(function (e) {
      $(".qv-product-swatch .ctm_swatches").each(function (e) {
        var len = $(this).find(".ctm_radios").length;
        if (len == 1) {
          //           $(this).closest('.ctm_swatches').addClass('hide');
        } else {
          $(this).closest(".ctm_swatches").removeClass("hide");
        }
      });
    }, 600);
    });

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = "";
      $("#quick-view select").each(function (i) {
        if (selectedOptions == "") {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + " / " + $(this).val();
        }
      });
      jQuery.getJSON("/products/" + product_handle + ".js", function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(
              2
            );
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            $(".qv-product-price").text("$" + price);
            $(".qv-product-original-price").text("$" + original_price);
            if (v_inv == null) {
              $(".qv-add-button").prop("disabled", false).val("Add to Cart");
              const swymBtn = document.querySelector(
                ".qv-add-to-cart__add-to-favourites .swym-button"
              );
              if (swymBtn) {
                swymBtn.dataset.variantId = v.id;
              }
            } else {
              if (v.inventory_quantity < 1) {
                $(".qv-add-button").prop("disabled", true).val("Sold Out");
              } else {
                $(".qv-add-button").prop("disabled", false).val("Add to Cart");
              }
            }
          }
        });
      });
    });

    $.fancybox({
      href: "#quick-view",
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: "75%",
      height: "70%",
      autoSize: false,
      closeClick: false,
      openEffect: "none",
      closeEffect: "none",
      beforeLoad: function () {
        setTimeout(function (e) {
          var product_handle = $("#quick-view").attr("class");

          if (Theme.settings.algolia_enabled) {
            (function (algolia) {
              try {
                var aa = algolia.externals.aa;
                aa.init({
                  appId: algolia.config.app_id,
                  apiKey: algolia.config.search_api_key,
                });
                var product = document.querySelector(
                  '[data-handle="' + product_handle + '"]'
                );
                if (product && product.dataset.algoliaQueryid) {
                  var clickData = {
                    index: Theme.settings.algolia.product_index,
                    eventName: "Quickview: Product Clicked",
                    objectIDs: [product.dataset.algoliaObjectid],
                    positions: [parseInt(product.dataset.algoliaPosition)],
                    queryID: product.dataset.algoliaQueryid,
                    userToken: window.Theme.settings.algolia.userToken,
                  };

                  aa.clickedObjectIDsAfterSearch(clickData);
                } else {
                  var clickData = {
                    index: Theme.settings.algolia.product_index,
                    eventName: "Quickview: Product Clicked",
                    objectIDs: [product.dataset.productId],
                    userToken: window.Theme.settings.algolia.userToken,
                  };

                  aa.clickedObjectIDs(clickData);
                }
              } catch (err) {
                console.error(err);
              }
            })(window.algoliaShopify);
          }

          $(".qv-add-button").unbind("click");
          $(".qv-add-button").off("click");
          $(".qv-add-button").on("click", async function (e) {
            e.preventDefault();
            var qty = $(".qv-quantity").val();
            var selectedOptions = "";
            var var_id = "";
            $("#quick-view select").each(function (i) {
              if (selectedOptions == "") {
                selectedOptions = $(this).val();
              } else {
                selectedOptions = selectedOptions + " / " + $(this).val();
              }
            });

            const productInCart = async () => {
              try {
                  const response = await fetch('/cart.js');
                  if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                const cart = await response.json();
                const qvPwrStars = document.querySelector('#qv-pwr-stars');
                const productId = qvPwrStars?.getAttribute('data-pr-page_id');
                if (!productId) return false;
                return cart.items.some((item) => {
                  return item.product_id == productId;
                });
                } catch (error) {
                  console.error('Error fetching cart:', error);
                  return false;
                }
              };

            const isProductInCart = await productInCart();
            
            jQuery.getJSON(
              "/products/" + product_handle + ".js",
              function (product) {
                // limit quantity start
                const limitQuantityElement = document.querySelector('.qv-add-to-cart .qv-add-to-cart__button');
                if (!limitQuantityElement) return;
                const errorMessage = document.querySelector('.limit-quantity-error');
                if (product.tags.includes("limit-quantity")) {
                  if (isProductInCart) {
                    if (!errorMessage) {
                      const newErrorMessage = document.createElement('p');
                      newErrorMessage.innerText = `Sorry! Only 1 of these items can be added per customer. More units cannot be added to your basket.`;
                      newErrorMessage.classList.add('limit-quantity-error');
                      limitQuantityElement.insertAdjacentElement('afterend', newErrorMessage);
                      newErrorMessage.classList.add('show');

                      setTimeout(() => {
                        newErrorMessage.classList.remove('show');
                      }, 8000);
                    }
                    limitQuantityElement.setAttribute('data-product-limit', "true");
                    return;
                  }
                } else {
                  if (errorMessage) errorMessage.remove();
                  limitQuantityElement.setAttribute('data-product-limit', "false");
                }
                limitQuantityElement.setAttribute('data-product-id', product.id);
                // end of limit quantity

                $(product.variants).each(function (i, v) {
                  if (v.title == selectedOptions) {
                    var_id = v.id;
                    processCart();
                  }
                });
              }
            );

            function processCart() {
              $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: {
                  quantity: qty,
                  id: var_id,
                },
                dataType: "json",
                success: function (data) {
                  pushAddedQuickViewItemDataToGTM(data);
                  $(".qv-add-button #AddToCartText").text("Added");
                  $(".qv-add-to-cart-response")
                    .addClass("success")
                    .html(
                      "<span>" +
                        $(".qv-product-title").text() +
                        ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>'
                    );
                  $("body").trigger("afterAddItem.ajaxCart", [data]);

                  // Flag so the ajax cart drawer opens when the cart finishes rebuilding
                  window.shouldOpenCartDrawer = true;
                  $(".header__cart .c-hide").show();
                  setTimeout(function (e) {
                    ShopifyAPI.fetchCart(window.buildCart);
                    //                     $('.desktop__header .header__cart a.site-header__cart-toggle')[0].click();
                  }, 600);

                  setTimeout(function (e) {
                    $(".fancybox-close").trigger("click");
                    $("body").addClass("ctm_mini_cart_active");
                  }, 800);
                },
                error: function (err) {
                  var data = err.responseJSON;
                  //                   $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
                  $(".qv-add-to-cart-response")
                    .addClass("error")
                    .html(
                      "<span>The last size of this item has already been added to your cart!</span>"
                    );
                },
              });
            }
          });
          $(".fancybox-wrap").css("overflow", "hidden !important");
        }, 2000);
      },
      afterShow: function () {
        // Force the popup to stay centered in the viewport and keep it that way
        // even as the app re-injects inline positioning (iOS structural fix).
        observeQuickViewPosition();

        if (Theme.settings.wishlist_enabled) {
          // Check if Swym tracking object is available before initializing
          if (window.st && typeof window.st.initialize === "function") {
            window.st.initialize();
          }
        }

        // Dispatch event for Swym button initialization after modal is shown
        document.dispatchEvent(new CustomEvent("quickview:open"));

        // Check variant_length after the product data has been loaded
        var checkVariantLength = function () {
          if (variant_length > 0) {
            if (variant_length < 2) {
              $(
                ".fancybox-wrap .qv-content .qv-add-to-cart .ctm_btn_action"
              ).hide();
              $(
                ".fancybox-wrap .qv-content .qv-add-to-cart .qv-add-button"
              ).removeClass("hide");
            }
          } else {
            // If variant_length is not set yet, check again after a delay
            setTimeout(checkVariantLength, 100);
          }
        };
        
        // Start checking
        setTimeout(checkVariantLength, 450);

        $("#quick-view")
          .hide()
          .html(content)
          .css("opacity", "1")
          .fadeIn(function () {
            $(".qv-product-images").addClass("loaded");
          });
      },
      afterClose: function () {
        stopQuickViewPositionObserver();
        $("#quick-view").removeClass().empty();
      },
    });

    $(document).on(
      "click",
      ".swatch-option-selection-colour .ctm_radios:not(.soldout)",
      function (e) {
        var val = $(this).data("value");
        $(this)
          .closest(".swatch-option-selection-colour")
          .find(".ctm_radios")
          .removeClass("ctm_active");
        $(this).addClass("ctm_active");
        $(this)
          .closest(".qv-add-to-cart")
          .find(".qv-product-options .option-selection-colour select")
          .val(val);
      }
    );

    $(document).on(
      "click",
      ".swatch-option-selection-size .ctm_radios:not(.soldout)",
      function (e) {
        console.log("clicked swatch button");
        var val = $(this).data("value");
        $(this)
          .closest(".swatch-option-selection-size")
          .find(".ctm_radios")
          .removeClass("ctm_active");
        $(this).addClass("ctm_active");
        $(this)
          .closest(".qv-add-to-cart")
          .find(".qv-product-options .option-selection-size select")
          .val(val);
        $(".qv-add-to-cart .ctm_btn_action").hide();
        $(".qv-add-to-cart .ctm_btn_trigger.qv-add-button").removeClass("hide");
      }
    );
    return false;
  });
}

$(window).resize(function () {
  if ($("#quick-view").is(":visible")) {
    $(".qv-product-images").slick("setPosition");
    forceQuickViewPosition();
  }
});
$(window).on("load", function (e) {
  $(".selector-wrapper select").each(function (e) {
    var len = $(this).find("option").length;
    if (len == 1) {
      $(this).closest(".selector-wrapper").addClass("hide");
    }
  });
  $(document).on("click", ".ctm_btn_action", function (e) {
    $(this).closest(".qv-add-to-cart").find(".err").remove();
    var _this = $(this);
    $(this)
      .closest(".qv-add-to-cart")
      .find(".qv-product-swatch")
      .append('<p class="err">Please select a size</p>');
    setTimeout(function (e) {
      _this.closest(".qv-add-to-cart").find(".err").remove();
    }, 5000);
  });

  

  $(document).on("click", ".coll_size_btn", function (e) {
    e.preventDefault();
    $.fancybox.open({
      href: "#coll_sizeguide_popup",
      //       maxWidth: 1040,
      //       maxHeight: 600,
      fitToView: true,
      //       width: '75%',
      //       height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: "none",
      closeEffect: "none",
      beforeLoad: function () {},
      afterShow: function () {},
      afterClose: function () {},
    });
    return false;
  });
});

// Added to quickview.js
// Call getQuickViewProductData(product) within jQuery.getJSON of quickView()

// On quick view modal open, this will send product data to GTM

const getQuickViewProductData = (data) => {
  const productData = data;
  let itemName;
  let itemSku;
  let itemBrand;
  let itemCategory = "";
  let itemSize;
  let itemColor;
  let thisItemData;
  let tagProductType;
  let tagProductCategory;
  let tagProductSubCategory;
  let itemTagCategory;
  let itemTagSubCategory;
  let itemTagProductType;
  let listName =
    document.querySelector("body").classList.value.replace("template-", "") +
    "-reco";
  const itemPrice =
    productData.price && typeof productData.price === "number"
      ? (productData.price / 100).toFixed(2)
      : "";
  const firstAvailableVariant = productData.variants.filter((obj) => {
    return obj.available === true;
  });

  if (document.querySelector("body").classList.contains("template-product")) {
    listName = "pdp-reco";
  }
  if (
    document.querySelector("body").classList.contains("template-collection")
  ) {
    listName = "plp-reco";
  }
  if (document.querySelector("body").classList.contains("template-cart")) {
    listName = "cart-reco";
  }

  if (typeof productData.tags !== "string") {
    tagProductType = productData.tags.filter((item) => {
      return item.includes("Product Type_");
    });
    if (
      typeof tagProductType != "undefined" &&
      tagProductType.length > 0 &&
      tagProductType[0].includes("Product Type_")
    )
      itemTagProductType = tagProductType[0].replace("Product Type_", "");
    tagProductCategory = productData.tags.filter((item) => {
      return item.includes("Category_");
    });
    if (
      typeof tagProductCategory != "undefined" &&
      tagProductCategory.length > 0 &&
      tagProductCategory[0].includes("Category_")
    )
      itemTagCategory = tagProductCategory[0].replace("Category_", "");
    tagProductSubCategory = productData.tags.filter((item) => {
      return item.includes("Sub Category_");
    });
    if (
      typeof tagProductSubCategory != "undefined" &&
      tagProductSubCategory.length > 0 &&
      tagProductSubCategory[0].includes("Sub Category_", "")
    )
      itemTagSubCategory = tagProductSubCategory[0].replace(
        "Sub Category_",
        ""
      );
    if (
      typeof itemTagProductType != "undefined" &&
      itemTagProductType.length > 0
    ) {
      itemCategory += itemTagProductType + " / ";
    }
    if (typeof itemTagCategory != "undefined" && itemTagCategory.length > 0) {
      itemCategory += itemTagCategory + " / ";
    }
    if (
      typeof itemTagSubCategory != "undefined" &&
      itemTagSubCategory.length > 0
    ) {
      itemCategory += itemTagSubCategory;
    }
  }

  itemCategory = itemCategory.toLowerCase();
  itemName = productData.title.toLowerCase();
  itemSku = firstAvailableVariant[0].sku.toLowerCase();
  itemBrand = productData.vendor.toLowerCase();
  itemSize = firstAvailableVariant[0].option2.toLowerCase();
  itemColor = firstAvailableVariant[0].option1.toLowerCase();

  thisItemData = {
    name: itemName,
    id: itemSku,
    price: itemPrice,
    brand: itemBrand,
    category: itemCategory,
    variant: itemSize,
    list: "pdp-reco",
    position: 1,
    dimension2: itemColor,
  };

  dataLayer.push({
    event: "productDetail",
    uaCategory: "quick view", //  event location
    uaAction: "product detail",
    uaLabel: listName, //original list name
    ecommerce: {
      detail: {
        actionField: { list: listName },
        products: [thisItemData],
      },
    },
  });
};

const pushAddedQuickViewItemDataToGTM = (data) => {
  let fetchPath = "/products/" + data.handle;
  if (data.url.includes("?variant=")) {
    fetchPath = data.url.split("?variant=")[0];
  }
  let itemName;
  let itemSku;
  let itemBrand;
  let itemCategory = "";
  let itemSize;
  let itemColor;
  let thisItemData;
  let itemProductType;
  let collectionOrigin = "";
  $.getJSON(fetchPath + ".js", (product) => {}).done(function (data) {
    const productData = data;
    let tagProductType;
    let tagProductCategory;
    let tagProductSubCategory;
    let itemTagCategory;
    let itemTagSubCategory;
    let itemTagProductType;
    const itemPrice = productData.price
      ? (productData.price / 100).toFixed(2)
      : "";
    const firstAvailableVariant = productData.variants.filter((obj) => {
      return obj.available === true;
    });
    collectionOrigin = document.querySelector(
      ".collection__header .section-header__title"
    )
      ? document
          .querySelector(".collection__header .section-header__title")
          .innerText.toLowerCase()
      : "";
    const listValue = "plp-" + collectionOrigin;
    let finalListValue;

    if (collectionOrigin.length > 0) {
      finalListValue = {
        list: listValue,
      };
    }

    if (typeof productData.tags !== "string") {
      tagProductType = productData.tags.filter((item) => {
        return item.includes("Product Type_");
      });
      if (
        typeof tagProductType != "undefined" &&
        tagProductType.length > 0 &&
        tagProductType[0].includes("Product Type_")
      )
        itemTagProductType = tagProductType[0].replace("Product Type_", "");
      tagProductCategory = productData.tags.filter((item) => {
        return item.includes("Category_");
      });
      if (
        typeof tagProductCategory != "undefined" &&
        tagProductCategory.length > 0 &&
        tagProductCategory[0].includes("Category_")
      )
        itemTagCategory = tagProductCategory[0].replace("Category_", "");
      tagProductSubCategory = productData.tags.filter((item) => {
        return item.includes("Sub Category_");
      });
      if (
        typeof tagProductSubCategory != "undefined" &&
        tagProductSubCategory.length > 0 &&
        tagProductSubCategory[0].includes("Sub Category_", "")
      )
        itemTagSubCategory = tagProductSubCategory[0].replace(
          "Sub Category_",
          ""
        );
      if (
        typeof itemTagProductType != "undefined" &&
        itemTagProductType.length > 0
      ) {
        itemCategory += itemTagProductType + " / ";
      }
      if (typeof itemTagCategory != "undefined" && itemTagCategory.length > 0) {
        itemCategory += itemTagCategory + " / ";
      }
      if (
        typeof itemTagSubCategory != "undefined" &&
        itemTagSubCategory.length > 0
      ) {
        itemCategory += itemTagSubCategory;
      }
    }
    itemCategory = itemCategory.toLowerCase();
    itemName = productData.title.toLowerCase();
    itemSku = firstAvailableVariant[0].sku.toLowerCase();
    itemBrand = productData.vendor.toLowerCase();
    itemSize = firstAvailableVariant[0].option2.toLowerCase();
    itemColor = firstAvailableVariant[0].option1.toLowerCase();

    thisItemData = {
      name: itemName,
      id: itemSku,
      price: itemPrice,
      brand: itemBrand,
      category: itemCategory,
      variant: itemSize,
      quantity: 1,
      position: 1,
      dimension2: itemColor,
    };

    let thisItemObj;

    if (collectionOrigin.length > 0) {
      thisItemObj = {
        event: "addToCart",
        uaCategory: "product page", // event location
        uaAction: "add to cart",
        uaLabel: listValue, //original list name
        ecommerce: {
          currencyCode: "CAD",
          add: {
            actionField: finalListValue,
            products: [thisItemData],
          },
        },
      };
    } else {
      thisItemObj = {
        event: "addToCart",
        uaCategory: "product page", // event location
        uaAction: "add to cart",
        // uaLabel: 'plp-sweatshirts', //original list name
        ecommerce: {
          currencyCode: "CAD",
          add: {
            products: [thisItemData],
          },
        },
      };
    }

    dataLayer.push(thisItemObj);
  });
};
